import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function CheckoutCancel() {
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white border border-ink/10 rounded-md p-8 text-center">
        <XCircle className="h-12 w-12 text-amber-500 mx-auto mb-4" />
        <h1 className="font-heading font-medium text-2xl text-ink mb-2">Paiement annulé</h1>
        <p className="text-muted-foreground text-sm mb-6">Vous avez annulé le paiement. Aucun montant n'a été débité.</p>
        <Link to="/events"><Button className="bg-ink hover:bg-ink/85 text-cream rounded-none">Retour aux événements</Button></Link>
      </div>
    </div>
  );
}
